
import React from 'react';
import { FormControl, FormField, FormItem, FormLabel } from '@/components/ui/form';
import { Checkbox } from '@/components/ui/checkbox';
import { UseFormReturn } from 'react-hook-form';
import { SYMPTOMS } from '@/data/symptoms';

interface SymptomCheckboxFieldProps {
  form: UseFormReturn<any>;
}

const SymptomCheckboxField: React.FC<SymptomCheckboxFieldProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="selectedSymptoms"
      render={() => (
        <FormItem>
          {SYMPTOMS.map((symptom) => (
            <FormField
              key={symptom.id}
              control={form.control}
              name="selectedSymptoms"
              render={({ field }) => {
                return (
                  <FormItem
                    key={symptom.id}
                    className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-3 my-2"
                  >
                    <FormControl>
                      <Checkbox
                        checked={field.value?.includes(symptom.id)}
                        onCheckedChange={(checked) => {
                          return checked
                            ? field.onChange([...field.value, symptom.id])
                            : field.onChange(
                                field.value?.filter((value) => value !== symptom.id)
                              );
                        }}
                      />
                    </FormControl>
                    <FormLabel className="font-normal cursor-pointer">
                      {symptom.label}
                    </FormLabel>
                  </FormItem>
                );
              }}
            />
          ))}
          
          {/* None option */}
          <FormField
            control={form.control}
            name="selectedSymptoms"
            render={({ field }) => {
              return (
                <FormItem
                  className="flex flex-row items-start space-x-3 space-y-0 rounded-md border p-3 my-2"
                >
                  <FormControl>
                    <Checkbox
                      checked={field.value?.includes('none')}
                      onCheckedChange={(checked) => {
                        if (checked) {
                          field.onChange(['none']);
                        } else {
                          field.onChange(field.value?.filter((value) => value !== 'none') || []);
                        }
                      }}
                    />
                  </FormControl>
                  <FormLabel className="font-normal cursor-pointer">
                    I'm not experiencing any symptoms
                  </FormLabel>
                </FormItem>
              );
            }}
          />
        </FormItem>
      )}
    />
  );
};

export default SymptomCheckboxField;

